export default {"src":"/_next/static/media/update.ef61b24f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};